function setNestedValue(obj, path, value) {
  const keys = path.split(".");
  keys.reduce((acc, current, idx) => {
    if (idx === keys.length - 1) {
      acc[current] = value;
    }
    return acc[current];
  }, obj);
  return obj;
}
function getNestedValue(obj, path) {
  const keys = path.split(".");
  return keys.reduce((acc, current) => {
    return acc[current];
  }, obj);
}
export {
  getNestedValue,
  setNestedValue
};
//# sourceMappingURL=nested.js.map
